<template>
  <div class="input-bar__container">
    <textarea
      class="input-bar__input-field"
      ref="inputField"
      v-model="message"
      :placeholder="`${ $t('commons.zapdoc.placeholder') }...`"
      :disabled="isLoading"
      @input="autoExpand">
    </textarea>
    <button class="input-bar__send-button" :disabled="isDisabled" @click="createMessage"><ArrowUp /></button>
  </div>
</template>

<script>
import ArrowUp from "./assets/arrow_up.vue"

export default {
  name: "InputBar",

  components: {
    ArrowUp
  },

  props: {
    isLoading: Boolean
  },

  data() {
    return {
      message: ""
    }
  },

  computed: {
    isDisabled() {
      return this.isLoading || this.message.trim() === ""
    }
  },

  methods: {
    createMessage() {
      if (this.message.trim() !== "") {
        this.$emit("create-message", this.message.trim())
        this.message = ""
        this.autoExpand()
      }
    },

    autoExpand(scrollToBottom = false) {
      this.$nextTick(() => {
        const textarea = this.$refs.inputField
        textarea.style.height = "44px"
        textarea.style.height = `${Math.max(textarea.scrollHeight, 44)}px`

        if (this.message.trim() !== "" && scrollToBottom) textarea.scrollTop = textarea.scrollHeight
      })
    },

    handleKeyDown(event) {
      if (event.key === "Enter" && !event.shiftKey) {
        event.preventDefault()
        this.createMessage()
      }
    }
  },

  mounted() {
    this.autoExpand()

    this.$refs.inputField.addEventListener("keydown", this.handleKeyDown)
  },

  beforeDestroy() {
    this.$refs.inputField.removeEventListener("keydown", this.handleKeyDown)
  }
}
</script>

<style scoped>
.input-bar__container {
  display: flex;
  justify-content: center;
  position: relative;
}

.input-bar__input-field {
  flex: 1;
  width: 100%;
  max-height: 160px;
  padding: 8px 12px;
  padding-right: 64px;
  border: 1px solid #000000;
  border-radius: 12px;
  box-sizing: border-box;
  overflow-y: auto;
  resize: none;
  border-color: rgba(0, 0, 0, 0.15);
}

.input-bar__input-field:focus {
  outline: none;
  border-color: rgba(0, 0, 0, 0.25);
  box-shadow: 0 4px 4px #c5cbd2;
  box-shadow: 0 0 transparent, 0 0 transparent, 0 2px 6px rgba(0, 0, 0, 0.05);
}

.input-bar__input-field:disabled {
  cursor: not-allowed;
}

.input-bar__input-field:disabled::placeholder {
  color: rgba(0, 0, 0, 0.15);
  cursor: not-allowed;
}

.input-bar__send-button {
  height: 30px;
  width: 30px;
  position: absolute;
  bottom: 7px;
  right: 16px;
  padding: 2px;
  border-radius: 8px;
  border: 1px solid #000000;
  background-color: #000000;
  padding: 0.125rem;
  color: #ffffff;
  transition: color 0.2s ease-in-out, background-color 0.2s ease-in-out, border-color 0.2s ease-in-out;
  cursor: pointer;
}

.input-bar__send-button:disabled {
  background-color: rgba(0, 0, 0, 0.25);
  border-color: rgba(0, 0, 0, 0.25);
  color: #ffffff;
  opacity: 0.1;
  cursor: not-allowed;
}
</style>
